export const api = {
  BASE_URL: "https://tennisnewapp.ru/api", // Новый API для всех запросов
  cart: {
    // Используется в src/redux/profile/grunt/asyncAction.ts
    GET_ALL_GRUNT_RESERVE: "api/allUserHasGruntReserveToday",
    GET_GRUNT_AREAS: (date: number) => `/api/getCourtsGrunt/${date}`
  },
  kassa: {
    // Используется в src/components/CardList/index.tsx
    GET_URL: (tokenData: string) => tokenData, // Просто возвращаем URL от YooKassa
  },
};

export const API_CONFIG = {
  SERVER_URL: 'https://tennisnewapp.ru/api',

  ADMIN_PANEL_USERNAME: 'TennisAdmin',
  ADMIN_PANEL_PASSWORD: 'yetr22Dasx',

  BITRIX_URL: 'https://prilt.tennis.ru/Tennis_rf/hs/mobileapp',
  BITRIX_USERNAME: 'Webservice',
  BITRIX_PASSWORD: 'rheujvdhfub',

  KASSA_MERCHANT_ID: '645398',
  KASSA_SECRET: 'live_4bcgZEIW4MiuLirHAHjwfTadsvaqdC2cFg-gvxWnYGc',

  YANDEX_API_KEY: '676d4f73-6539-413f-be14-c5b4cd05eaa0'
};